var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExilio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "28px",
    viewBox: "0 0 23 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-exilio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P\\xE1gina-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post-Square",
    transform: "translate(-284, -431)",
    fill: "#A3233B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-exilio",
    transform: "translate(284, 431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.993,16.99 L4.987,19.248 L1.75,19.248 C0.782,19.248 0,20.03 0,20.998 C0,21.966 0.782,22.748 1.75,22.748 L5.556,22.748 C6.595,22.748 7.535,22.136 7.956,21.19 L8.585,19.773 L8.065,19.445 C7.108,18.849 6.398,17.98 5.993,16.99 M20.998,12.249 L19.833,12.249 C19.128,12.249 18.488,11.823 18.22,11.172 L17.875,10.352 C17.077,8.432 15.464,6.967 13.473,6.354 L10.81,5.534 C10.203,5.348 9.569,5.25 8.929,5.25 C7.234,5.25 5.605,5.922 4.407,7.125 L3.139,8.389 C2.455,9.072 2.455,10.182 3.139,10.866 C3.822,11.549 4.932,11.549 5.616,10.866 L6.879,9.603 L6.873,9.597 C7.415,9.056 8.153,8.75 8.924,8.75 C9.028,8.75 9.132,8.755 9.23,8.766 L7.524,13.89 C7.016,15.421 7.617,17.105 8.99,17.963 L13.703,20.911 L12.314,25.766 C12.046,26.696 12.588,27.664 13.517,27.932 C14.447,28.2 15.415,27.658 15.683,26.729 L17.252,21.239 C17.575,20.112 17.11,18.909 16.12,18.291 L13.014,16.35 L14.704,11.845 L14.983,12.517 C15.803,14.475 17.711,15.749 19.833,15.749 L20.998,15.749 C21.966,15.749 22.747,14.967 22.747,13.999 C22.747,13.031 21.966,12.249 20.998,12.249 M12.249,2.625 C12.249,1.176 13.424,0 14.873,0 C16.322,0 17.498,1.176 17.498,2.625 C17.498,4.074 16.322,5.25 14.873,5.25 C13.424,5.25 12.249,4.074 12.249,2.625",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExilio);
export default __webpack_public_path__ + "static/media/ico-exilio.64d30837.svg";
export { ForwardRef as ReactComponent };